module.exports = __webpack_public_path__ + "/d58ad3a77f60df89e43cefa5cffd9b98.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/images/hello.svg
 ** module id = 1022
 ** module chunks = 0
 **/